import { z } from 'zod';
// Create validation and DTO type
export const meetingBodyCategoryCreateSchema = z.object({
    name: z
        .string('Name is required')
        .min(1, 'Name is required')
        .max(300, 'Name must be less than 300 characters'),
    description: z.string('Description is required').min(1, 'Description is required'),
});
// Update validation and DTO type
export const meetingBodyCategoryUpdateSchema = meetingBodyCategoryCreateSchema.extend({
    name: z
        .string('Name is required')
        .min(1, 'Name is required')
        .max(300, 'Name must be less than 300 characters')
        .optional(),
    description: z.string('Description is required').min(1, 'Description is required').optional(),
});
